import React from 'react';
import { Course } from '../types/grades';
import { calculateGPA } from '../utils/calculations';
import { useUniversity } from '../contexts/UniversityContext';
import { Card } from './layout/Card';

interface GPADisplayProps {
  courses: Course[];
  cumulativeGPA: number;
}

export function GPADisplay({ courses, cumulativeGPA }: GPADisplayProps) {
  const { selectedUniversity } = useUniversity();
  const stats = calculateGPA(courses, selectedUniversity);

  const getGPAColor = (gpa: number): string => {
    if (gpa >= 3.5) return 'text-green-600';
    if (gpa >= 2.5) return 'text-blue-600';
    if (gpa >= 2.0) return 'text-yellow-600';
    return 'text-red-600';
  };

  return (
    <Card className="text-center">
      <h2 className="text-2xl font-bold mb-4">Your GPA</h2>
      <div className={`text-5xl font-bold mb-2 ${getGPAColor(stats.effectiveGPA)}`}>
        {stats.effectiveGPA.toFixed(2)}
      </div>
      <div className="space-y-2 mt-4 text-sm">
        <p className="text-gray-600">
          Total Credits: {stats.totalCredits}
        </p>
        <p className="text-gray-600">
          Effective Credits: {stats.effectiveCredits}
        </p>
        {stats.specialGradeCredits > 0 && (
          <p className="text-blue-600">
            Special Grade Credits: {stats.specialGradeCredits}
          </p>
        )}
      </div>
    </Card>
  );
}